import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AchatService } from '../../../../services/achat/achat.service';
import { HeaderService } from '../../../../services/header/header.service';
import { ExportService } from '../../shared/export.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-avoir-fournisseur',
  templateUrl: './avoir-fournisseur.component.html',
  styleUrls: ['./avoir-fournisseur.component.scss']
})
export class AvoirFournisseurComponent implements OnInit {

    currentStatus: string = 'tous';
    statuses: { path: string; label: string; status: string }[] = [
        { path: 'tous', label: 'Tous', status: 'Tous' },
        { path: 'brouillon', label: 'Brouillon', status: 'Brouillon' },
        { path: 'non-utilise', label: 'Non utilisé', status: 'Non utilisé' },
        { path: 'partiellement-utilise', label: 'Partiellement utilisé', status: 'Partiellement utilisé' },
        { path: 'utilise', label: 'Utilisé', status: 'Utilisé' },
        { path: 'annule', label: 'Annulé', status: 'Annulé' }
    ];
    currentUser: any = null;
    stationId: number | null = null;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private achatService: AchatService,
        private headerService: HeaderService,
        private exportService: ExportService,
        private toastr: ToastrService
    ) {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
        this.stationId = this.currentUser?.stations?.[0]?.id || null;
    }

    ngOnInit(): void {
        this.headerService.setConfig({
            title: 'Avoir Fournisseur',
            buttons: [
                {
                    label: 'Exporter',
                    type: 'dropdown',
                    dropdownItems: [
                        { label: 'PDF', action: () => this.exportService.triggerPDF(), icon: '../../../assets/images/logo/pdf_logo.png' },
                        { label: 'CSV', action: () => this.exportToCSV(), icon: '../../../assets/images/logo/csv_logo.png' }
                    ]
                }
            ]
        });
        this.route.firstChild?.url.subscribe(segments => {
            const path = segments?.length > 0 ? segments[0].path : 'tous';
            const item = this.statuses.find(s => s.path === path);
            this.currentStatus = item ? item.path : 'tous';
        });
    }

    filterByStatus(path: string, status: string) {
        this.currentStatus = path;
        this.achatService.filterAvoirFournisseurByStatus(status);
        this.router.navigate([`/achat/avoir-fournisseur/${path}`]);
    }

    getStatusCount(status: string): number {
        const data = this.achatService.getAvoirFournisseurTableData() || [];
        return status === 'Tous' ? data.length : data.filter((i: any) => i.status === status).length;
    }

    private exportToCSV(): void {
        const avoirs = this.achatService.getAvoirFournisseurTableData() || [];
        const headers = ['Référence', 'Fournisseur', 'Date', 'Revenu', 'Statut'];
        const rows = avoirs.map((item: any) => [
            `"${(item.reference || '').replace(/"/g, '""')}"`,
            `"${(item.clientName || '').replace(/"/g, '""')}"`,
            `"${(item.date || '').replace(/"/g, '""')}"`,
            `"${(item.revenue || '').replace(/"/g, '""')}"`,
            `"${(item.status || '').replace(/"/g, '""')}"`
        ]);
        const csvContent = headers.join(',') + '\n' + rows.map((row: string[]) => row.join(',')).join('\n');
        this.exportService.downloadCSV(csvContent, 'avoir-fournisseur.csv');
    }
}
